import API from "./../../../servicos/API";

import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Spinner } from "../../../componentes/Spinner";

import { ContextoGeral } from "../../../contextos/ContextoGeral";

import { motion } from "framer-motion";

import imgSemconexao from "../../../assets/sem-conexao.png";
import MensagemApp from "../../../servicos/config/MensagemApp";

import "swiper/css";
import "swiper/css/pagination";
import "./home.module.css";

import { MdInfo } from "react-icons/md";
import { configAnim } from "../../../servicos/config/configAnim";

import { Button } from "@mui/material";
import Refresher from "../../../componentes/uteis/Refresher";
import ProfissionalAPI from "../../../servicos/ProfissionalAPI";

export function Home() {
	const [stages, setStages] = useState([])

	const [requesting, setRequesting] = useState(true)
	const [semDominio, setSemDominio] = useState(false)

	const [reqPaineis, setReqPaineis] = useState(true)

	const [linkTermos, setLinkTermos] = useState("")

	const { dados } = useContext(ContextoGeral)
	const navegar = useNavigate()

	const [btmHeight, setBtmHeight] = useState("")

	async function termoDeUso() {
		let retorno = await ProfissionalAPI.buscarTermosUso(dados);

		if (retorno?.resultado) {
			if (retorno.dados != "" && retorno.dados.link != "") {
				setLinkTermos(retorno.dados.link);
			}
		}
	}

	async function buscarPaineis() {
		await ProfissionalAPI.buscarTelaInicial(dados).then(res => {
			if (res?.resultado) setStages(res.dados)
		}).catch((rej) => {
			console.log(rej)
		}).finally(() => {
			setReqPaineis(false);
			termoDeUso()
		})
	}

	useEffect(() => {
		if (stages.length > 0) {
			setRequesting(false);
		}
	}, [stages]);

	useEffect(() => {
		(async function () {
			if (requesting) {
				if (dados.dominio) {
					await buscarPaineis();
				} else {
					setSemDominio(true);
				}
			}
		})();
	}, [])

	useLayoutEffect(() => {
		if (document.querySelector("#btm")) {
			let el = document.querySelector("#btm")
			setBtmHeight(el.offsetHeight)
		}
	})

	return <>
		<motion.div
			className="corpo"
			style={{ paddingTop: 'var(--safe-top, 0px)' }}
			initial={configAnim.initial}
			animate={configAnim.animate}
			exit={configAnim.exit}
			transition={configAnim.transition}
		>
			{semDominio ? (
				<div className="flex items-center" style={{ height: "100%" }}>
					<img
						src={imgSemconexao}
						alt="você está sem conexão"
						style={{
							width: "100vw",
							marginLeft: "-0.5rem",
						}}
					/>
					<div className="absolute w-full flex justify-center" style={{ bottom: "3rem" }}>
						<Refresher onClick={() => {
							if (window.AndroidInterface)
								window.AndroidInterface.reloadPage()
						}} />
					</div>
				</div>
			) : (
				<motion.div
					initial={{
						opacity: 0,
					}}
					animate={{
						opacity: 1,
					}}
					exit={{
						opacity: 0,
						x: "-125%",
					}}
					transition={{ ease: "easeInOut", duration: 0.5 }}
					style={{ height: "100%" }}
				>
					{requesting ? (
						<div className="corpo">
							<Spinner />
						</div>
					) : (
						<>
							{reqPaineis
								? <div className="h-screen">
									<Spinner />
								</div>
								: <>
									{stages.length > 0
										? <Swiper
											effect={"coverflow"}
											grabCursor={true}
											centeredSlides={true}
											slidesPerView={"auto"}
											coverflowEffect={{
												rotate: 50,
												stretch: 0,
												depth: 100,
												modifier: 1,
												slideShadows: true,
											}}
											pagination={true}
											modules={[Pagination]}
										>
											{stages.length && stages.map(function (i, e) {
												return <SwiperSlide
													key={i.key}
													style={{
														paddingTop: "1rem",
														height: `calc(var(--home-vh-full) - (${btmHeight}px + 1.5rem) - var(--safe-top, 0px))`,
													}}
												>
													<div className="ajustarVertical" >
														<div className="text-center">
															<h4 style={{ fontSize: "calc(0.25rem + var(--home-vh-title))" }}>{i.title}</h4>
														</div>
														<div
															className="blocoImagem"
															style={{ height: `calc(var(--home-vh-70) - ${btmHeight}px - var(--safe-top, 0px))` }}
														>
															<img src={i.image} className="imagemPainel" alt="" />
														</div>
														<p className="textCenter small" style={{
															lineHeight: 1
														}}>{i.description}</p>
													</div>
												</SwiperSlide>
											})}
										</Swiper>
										: <div className="h-screen w-full flex items-center">
											<div className="flex flex-col items-center gap-4 text-center p-3">
												<MdInfo size={42} />
												{MensagemApp.erroPaineis}
											</div>
										</div>}
								</>}

							<div id="btm" className="toBottom">
								<div className="fullCenter">
									<Link to="/login">
										<Button variant="contained" fullWidth>
											Entrar
										</Button>
									</Link>
								</div>
								<div className="fullCenter mt-2">
									<Link to="/cadastro">
										<Button variant="outlined" fullWidth>
											Cadastrar
										</Button>
									</Link>
								</div>
								<div className="flex justify-between mt-2">
									<Button size="small" onClick={() => navegar('/app/politicaPrivacidade')}><small>Política de privacidade</small></Button>
									{linkTermos && <Button size="small" onClick={() => navegar('/app/termosUso', { state: { link: linkTermos } })}><small>Termos de uso</small></Button>}
								</div>
							</div>
						</>
					)}
				</motion.div>
			)}
		</motion.div>
	</>
}
